import React from 'react'
import { TableRow } from '@material-ui/core'
import DefaultTableCellSmallSpace from './DefaultTableCellSmallSpace'
import moment from 'moment'
import { getDaysInMonth, DaysInMonth } from '../utils/Helpers'

type Props = {
  title: string
}
export default function EmptyCellsSmall ({ title }: Props): JSX.Element {
  return (
    <TableRow>
      <DefaultTableCellSmallSpace>{title}</DefaultTableCellSmallSpace>
      {getDaysInMonth(moment().year(), moment().month() + 1).map((day: DaysInMonth) => {
        return <DefaultTableCellSmallSpace key={day.date} className={day.isWeekend ? 'weekend' : ''}>-</DefaultTableCellSmallSpace>
      })}
    </TableRow>
  )
}
